export default "/images/hg-billing.png";